import Icon from '@/components/ui/AppIcon';

interface TrustBadge {
  icon: string;
  title: string;
  description: string;
}

export default function TrustBadges() {
  const badges: TrustBadge[] = [
    {
      icon: 'ShieldCheckIcon',
      title: 'BBB A+ Rated',
      description: 'Accredited Business'
    },
    {
      icon: 'StarIcon',
      title: '4.9/5 Rating',
      description: 'From 500+ Reviews'
    },
    {
      icon: 'UserGroupIcon',
      title: '5+ Years',
      description: 'Serving Community'
    },
    {
      icon: 'CheckBadgeIcon',
      title: '100% Retention',
      description: 'Customer Return Rate'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
      {badges.map((badge, index) => (
        <div
          key={index}
          className="bg-card rounded-lg shadow-brand-sm p-6 text-center transition-smooth hover:shadow-brand"
        >
          <div className="inline-flex items-center justify-center w-14 h-14 bg-accent rounded-full mb-4">
            <Icon name={badge.icon as any} size={28} variant="solid" className="text-primary" />
          </div>
          <h3 className="font-serif text-lg font-semibold text-foreground mb-1">{badge.title}</h3>
          <p className="text-sm text-muted-foreground">{badge.description}</p>
        </div>
      ))}
    </div>
  );
}